import React from 'react';
import colors from 'utils/colors';
import styled from 'styled-components';
import {
  Table,
  ResultsHoverTableRow,
  ResultsHeader,
  TableData,
  ResultsHeaderRow,
  ResultsData,
} from 'components/styled-components';
import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import moment from 'moment';
import { NonIdealState } from '@blueprintjs/core';
import Loading from 'components/loading';
import map from 'lodash/map';
import { shouldBold } from 'utils/functions';

const fields = [
  { name: 'Third Party Name', orderby: 'vendorName' },
  { name: 'Status', orderby: 'vendorStatus' },
  { name: 'Certificate on File', orderby: 'certificate' },
  { name: 'Renewal Date', orderby: 'renewalDate' },
  { name: 'Product / Service', orderby: 'productServiceName' },
  { name: 'Assessment ID', orderby: 'vendorID' },
];

const VendorTable = ({
  vendors,
  handleOrderByClick,
  orderby,
  orderDesc,
  handleEditClick,
  isFetching,
  query,
}) => (
  <Table>
    <tbody>
      <ResultsHeaderRow>
        {map(fields, field => (
          <SortableTableHeader
            key={field.orderby}
            onClick={() => handleOrderByClick(field.orderby)}
          >
            {field.name}
            <StyledIcon
              icon={
                orderby === field.orderby && !orderDesc
                  ? IconNames.SORT_DESC
                  : IconNames.SORT_ASC
              }
              color={colors.gray}
            />
          </SortableTableHeader>
        ))}
      </ResultsHeaderRow>
      {isFetching && (
        <tr>
          <TableData colSpan={5}>
            <Loading size={100} />
          </TableData>
        </tr>
      )}
      {!vendors && !isFetching && (
        <tr>
          <TableData colSpan={5}>
            <NonIdealState
              icon="search"
              title="No Third Parties were found"
              description="The Third Party you are searching for could not be found."
            />
          </TableData>
        </tr>
      )}
      {vendors &&
        vendors.map(v => (
          <ResultsHoverTableRow
            key={v.vendorID}
            onClick={() => handleEditClick(v)}
          >
            <TableDataWithHeaders>
              {shouldBold(v.vendorName, query)}
            </TableDataWithHeaders>
            <TableDataWithHeaders>
              {shouldBold(v.status, query)}
            </TableDataWithHeaders>
            <TableDataWithHeaders>
              {v.certificate ? 'Yes' : 'No'}
            </TableDataWithHeaders>
            <TableDataWithHeaders>
              {moment(v.renewalDate).isValid()
                ? moment(v.renewalDate).format('MMMM Do YYYY')
                : 'N/A'}
            </TableDataWithHeaders>
            <TableDataWithHeaders>
              {v.productServiceName || 'N/A'}
            </TableDataWithHeaders>
            <TableDataWithHeaders>
              {v.vendorRequestID || 'N/A'}
            </TableDataWithHeaders>
          </ResultsHoverTableRow>
        ))}
    </tbody>
  </Table>
);

const SortableTableHeader = styled(ResultsHeader)`
  &:hover {
    cursor: pointer;
  }
`;

const StyledIcon = styled(Icon)`
  transition: all 0.3s ease;
  opacity: 0;
  margin-left: 1rem;
  ${SortableTableHeader}:hover & {
    opacity: 1;
  }
`;

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'Third Party Name';
    }
    &:nth-of-type(2):before {
      content: 'Status';
    }
    &:nth-of-type(3):before {
      content: 'Certificate on File';
    }
    &:nth-of-type(4):before {
      content: 'Renewal Date';
    }
    &:nth-of-type(5):before {
      content: 'Product / Service';
    }
    &:nth-of-type(6):before {
      content: 'Assessment ID';
    }
  }
`;

export default VendorTable;
